/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseBasicField
 */
export interface DatabaseBasicField extends DatabaseField {
}

/**
 * Check if a given object implements the DatabaseBasicField interface.
 */
export function instanceOfDatabaseBasicField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseBasicFieldFromJSON(json: any): DatabaseBasicField {
    return DatabaseBasicFieldFromJSONTyped(json, false);
}

export function DatabaseBasicFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseBasicField {
    return json;
}

export function DatabaseBasicFieldToJSON(value?: DatabaseBasicField | null): any {
    return value;
}

